var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 180",
    style: {
      enableBackground: "new 0 0 180 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#626362;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M173.9,42.7h-36.5v-26c0-3-2.5-5.5-5.5-5.5H48.3c-3,0-5.5,2.5-5.5,5.5v25.9H6.3c-3,0-5.5,2.5-5.5,5.5v68 c0,3,2.5,5.5,5.5,5.5h5v41.7c0,3,2.5,5.5,5.5,5.5h146.5c3,0,5.5-2.5,5.5-5.5v-41.7h5c3,0,5.4-2.5,5.4-5.5v-68 C179.3,45.2,176.9,42.7,173.9,42.7 M53.7,22.2h72.8v20.5H53.7L53.7,22.2L53.7,22.2z M157.9,157.9H22.4v-36.2h51.3l1.5,2.5 c0.5,0.9,2,2.7,4.5,2.7h20.9c1.8,0,3.5-1,4.6-2.8l1.4-2.5h51.3V157.9z M168.4,110.7h-61.8l-1.4-2.5c-0.5-0.9-1.9-2.7-4.5-2.7H79.8 c-2.6,0-4.1,2-4.5,2.8l-1.5,2.5H12V53.7h156.5L168.4,110.7L168.4,110.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffices);
export default __webpack_public_path__ + "static/media/offices.4156e66f2abbf4d642d4ebd9d4e666a5.svg";
export { ForwardRef as ReactComponent };